// extracted by mini-css-extract-plugin
module.exports = {"guestSuccessWrapper":"GuestSuccess_guestSuccessWrapper__1IG8D","guestAppointmentSuccessfulHeader":"GuestSuccess_guestAppointmentSuccessfulHeader__2kkB-"};